import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { onboardingApi } from "@/redux/apis/onboarding/onboardingApi";
import { SoloScenarioId } from "@/components/organisms/SoloOperatorGetStarted/data/driverAppScenarios";
import { QuickSetupState, QuickSetupSection } from "./types";

export const quickSetupInitialState: QuickSetupState = {
  cameFromQuickSetup: false,
  lastClickedSection: null,
  lastOpenedPanel: "1-getting-started",
  hasSeenOnboardingCompleteModal: false,
  hasSeenSimulationCompleteSnackbar: false,
  hasSeenPreSimulationModal: false,
  isOnboardingComplete: null,
  selectedSoloScenarioByOperator: {},
};

export const quickSetupSlice = createSlice({
  name: "quickSetup",
  initialState: quickSetupInitialState,
  reducers: {
    setQuickSetupNavigationFlag: (state, action: PayloadAction<{ section?: QuickSetupSection }>) => {
      state.cameFromQuickSetup = true;
      state.lastClickedSection = action.payload.section || null;
    },
    resetQuickSetupNavigation: (state) => {
      state.cameFromQuickSetup = false;
      state.lastClickedSection = null;
    },
    setLastOpenedPanel: (state, action: PayloadAction<string | null>) => {
      state.lastOpenedPanel = action.payload;
    },
    setHasSeenOnboardingCompleteModal: (state, action: PayloadAction<boolean>) => {
      state.hasSeenOnboardingCompleteModal = action.payload;
    },
    setHasSeenSimulationCompleteSnackbar: (state, action: PayloadAction<boolean>) => {
      state.hasSeenSimulationCompleteSnackbar = action.payload;
    },
    setHasSeenPreSimulationModal: (state, action: PayloadAction<boolean>) => {
      state.hasSeenPreSimulationModal = action.payload;
    },
    // redux-persist runs with no stateReconciler, so a payload stored before this field existed
    // replaces the slice wholesale and arrives without it.
    setSoloScenario: (state, action: PayloadAction<{ operatorId: string; scenario: SoloScenarioId }>) => {
      state.selectedSoloScenarioByOperator = { ...state.selectedSoloScenarioByOperator, [action.payload.operatorId]: action.payload.scenario };
    },
    clearSoloScenario: (state, action: PayloadAction<string>) => {
      const { [action.payload]: _removed, ...rest } = state.selectedSoloScenarioByOperator ?? {};
      state.selectedSoloScenarioByOperator = rest;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(onboardingApi.endpoints.getOnboardingStatus.matchFulfilled, (state, action) => {
      state.isOnboardingComplete = action.payload.overallCompletion.isOnboardingComplete;
    });
  },
});

export const {
  setQuickSetupNavigationFlag,
  resetQuickSetupNavigation,
  setLastOpenedPanel,
  setHasSeenOnboardingCompleteModal,
  setHasSeenSimulationCompleteSnackbar,
  setHasSeenPreSimulationModal,
  setSoloScenario,
  clearSoloScenario,
} = quickSetupSlice.actions;

export default quickSetupSlice.reducer;
